import { render } from "./CampaignData.vue?vue&type=template&id=42cc5279"
import script from "./CampaignData.vue?vue&type=script&lang=js"
export * from "./CampaignData.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__